module.exports = __webpack_public_path__ + "static/img/ent-30.9c5899d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-30.jpg
// module id = uuIo
// module chunks = 52